import React from 'react'
import PropTypes from 'prop-types'

const Link = ({ children, to, blank = false, ...rest }) => {
  return (
    <a
      href={to}
      target={blank ? '_blank' : ''}
      rel={blank ? 'noopener noreferrer' : ''}
      onMouseDown={(e) => e.preventDefault()}
      {...rest}
    >
      {children}
    </a>
  )
}

Link.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
  blank: PropTypes.bool,
}

export default Link
